module.exports = __webpack_public_path__ + "img/92119.7c01026a.svg";